var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2488_3361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.916748 3.6667V9.1667M0.916748 9.1667H6.41675M0.916748 9.1667L5.17008 5.17003C6.15527 4.18435 7.37409 3.4643 8.71282 3.07707C10.0516 2.68984 11.4666 2.64805 12.8258 2.9556C14.1851 3.26315 15.4443 3.91001 16.4859 4.83583C17.5275 5.76165 18.3177 6.93625 18.7826 8.25003M21.0834 18.3334V12.8334M21.0834 12.8334H15.5834M21.0834 12.8334L16.8301 16.83C15.8449 17.8157 14.6261 18.5358 13.2873 18.923C11.9486 19.3102 10.5336 19.352 9.17434 19.0445C7.81509 18.7369 6.5559 18.09 5.51426 17.1642C4.47262 16.2384 3.68249 15.0638 3.21758 13.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2488_3361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.96f33900ff95f7060dcdc943674526cb.svg";
export { ForwardRef as ReactComponent };